import React from 'react';

/**
 * Phase 15.3 - Empty State Component
 * Beautiful empty states with animations
 */
const EmptyState = ({ 
  icon = '📭', 
  title = 'Keine Daten', 
  description = 'Es wurden noch keine Daten gefunden',
  action = null,
  className = ''
}) => {
  return (
    <div className={`bg-neutral-900/80 backdrop-blur-xl rounded-3xl p-12 shadow-hayat-md text-center border border-neutral-600/40 ${className}`}>
      <div className="max-w-md mx-auto animate-fade-in-up">
        {/* Animated Icon */}
        <div className="text-7xl mb-6 animate-bounce-soft inline-block">
          {icon}
        </div>
        
        {/* Title */}
        <h3 className="text-2xl font-bold text-[#F9FAFB] mb-3">
          {title}
        </h3>
        
        {/* Description */}
        <p className="text-neutral-500 mb-6">
          {description}
        </p>
        
        {/* Optional Action */}
        {action && (
          <div className="animate-scale-in" style={{ animationDelay: '0.2s' }}>
            {action}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
